import 'css-chunksrc/client/common/filterMenu/search/styles.scss';export default {
  "search": "_search_1n6uk_1"
};